import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hibp = defineConnector({
  identifier: "hibp",
  name: "Have I Been Pwned",
  tagLine: "Breach and password lookup",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://haveibeenpwned\\.com/api/.*",
  auth: (app) =>
    headerAuth([{ name: "hibp-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Have I Been Pwned API key page](https://haveibeenpwned.com/API/Key) to purchase an API key. The key is required for searching breaches by email address.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "HIBP API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://haveibeenpwned.com/api/v3/breaches",
  },
});
